<script lang="ts">
  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()
</script>

{#if course_progress.substep === 1}
  <p class="text-center text-3xl font-bold">Module 4: Blue Sky Vision</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      This learning module is focused on giving you everything you need to
      develop your company's Blue Sky Vision (BSV). Your Blue Sky Vision
      represents for you, your employees, and your customers an inspiring story
      of what it looks and feels like to be in your company five years in the
      future. I walk you through the steps you need to follow and provide you
      with the Blue Sky Vision Chapter along with the “Blue Sky Vision Table”
      (Download Assets). I share examples that are helpful and then you “Do The
      Work” and identify your own Blue Sky Vision.
    </p>

    <p class="mt-6 text-lg">
      By going through this module, you will better understand What a Blue Sky
      Vision is, Why it is Important, and the steps you need to follow to create
      your own. You will then work on your Blue Sky Vision and enter it into
      your One Page Alignment Plan.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084348"
        class="absolute inset-0 w-full h-full"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 2}
  <p class="text-center text-3xl font-bold">4.2 What is it?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I teach you the definition of a Blue Sky Vision and share with you two
      Blue Sky Vision examples.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084392"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 3}
  <p class="text-center text-3xl font-bold">4.3 Why is it Important?</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      You learn the three reasons the Blue Sky Vision is important and the
      positive impact it will have on you, your employees, and your customers.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084480"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 4}
  <p class="text-center text-3xl font-bold">4.4 How to Develop</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I teach you the process you need to follow to craft your Blue Sky Vision
      (detailed in the Blue Sky Vision chapter provided in Download Assets). I
      share with you the ten questions that will help you start putting together
      your five year story and show you where these are located on the Blue Sky
      Vision Table.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084563"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 5}
  <p class="text-center text-3xl font-bold">4.5 Flint Inc. Blue Sky Vision</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      I share with you how the President of Flint Inc. used the Blue Sky Vision
      table to create the descriptive story of what it looks and feels like to
      be in Flint Inc. five years in the future. This example shows how he
      initially came close to the Blue Sky Vision statement and how the
      statement was refined over several weeks with feedback and insights from
      employees, customers, and family.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084686"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 6}
  <p class="text-center text-3xl font-bold">4.6 Do the Work</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I walk you through the process and provide everything you
      need to craft your company's inspiring Blue Sky Vision. Read the Blue Sky
      Vision Chapter and print out a blank Blue Sky Vision Table (Download
      Assets) and then go ahead and have fun transporting yourself five years in
      the future. You Can Do This!!
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084751"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{:else if course_progress.substep === 7}
  <p class="text-center text-3xl font-bold">4.7 Wrap Up</p>

  <div class="px-12">
    <p class="mt-6 text-lg">
      In this video, I ask you to reflect upon the Blue Sky Vision module. I end
      the video by giving you a brief overview of the SWOT module which is next.
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/284084840"
        class="absolute inset-0 w-full h-full border border-gray-200"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E1 Course"
      ></iframe>
    </div>
  </div>
{/if}
